module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm07_ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("In August 1951, Helen Keller’s dear friend Jo Davidson finished the book he’d been working on for years. She wrote to him with congratulations, “It delighted us to read the news that your autobiography has actually been finished and pushed out of the house into the hands of the publisher.” In my case, many people helped to finish this project and push it out of the house into the hands of others. Eric Zinner shepherded the project. The American Foundation for the Blind and its staff members—especially Maureen Matheson, Natalie Hilzen, Regina Genwright, Helen Selsdon, and Daniel Cuff—assisted graciously, cheerfully, and with generosity. Staff at the Library of Congress, Perkins School for the Blind, and the Schlesinger Library helped in the early stages of this project. Paul Long-more and Lauri Umansky, as usual, performed intellectual and editing magic. Craig Jones of the Reader’s Loft bookstore of DePere, Wisconsin found every out-of-print book I sought and made it look easy. My colleagues at the University of Wisconsin-Green Bay answered questions and gave much appreciated advice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are many others I could not do without. Cathy Kudlick and Georgina Kleege responded to numerous comments and questions about Helen Keller. Susan Burch provided cheerleading when I needed it. Becky Dale always asked how Keller and I were getting along. Ron and Kathie Nielsen model parenthood extraordinaire. Unbounded praise and appreciation goes to Nathan Tuff for cheerfully listening to more Helen Keller stories than any human being should ever have to endure, and for making everything else in life sweet. Morgan and Maya continue to make life chaotically wonderful."), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f77740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm07_ack.vue
// module id = 75
// module chunks = 0